export default __webpack_public_path__ + "static/harvest-finance-logo-bc4cbccfc9caa0895d8213637a36a988.svg";